import { CallChaining, FormFieldWidget, ModelFieldType, SPI, ViewType, Widget, http } from '@kunlun/dependencies';
import ProjectProcess from './ProjectProcess.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'ProjectProcess',
    multi: false
  })
)
export class FormStringProjectProcessWidget extends FormFieldWidget {
  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  @Widget.Reactive()
  private pdata: any = [];

  public initialize(props) {
    super.initialize(props);
    this.setComponent(ProjectProcess);
    return this;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  private async mountedProcess() {
    const res = await this.getProgressData(this.formData.id as string);
    res.sort((a, b) => a.sort - b.sort);
    this.pdata = res;
  }

  private async getProgressData(pid: string) {
    const gql = `
      query {
        venusProjectFlowChartInfosQuery {
          queryFlowChartInfos(data: {projectId: ${pid}}) {
            projectId
            stageEnum
            nodeEnum
            dealState
            sort
            dealStaffName
            dealTime
          }
        }
      }
    `;
    const res = await http.query<any[]>('venusPmpModule', gql);
    return res.data.venusProjectFlowChartInfosQuery.queryFlowChartInfos;
  }
}
